import React from 'react';
import { Box } from '@mui/material';
import { COLORS } from './tokens';

/**
 * The push notification card itself. Shared by the desktop lock screen
 * (PhoneWithPush).
 */
export default function NotificationCard({
    storeName,
    title,
    text,
    time = 'agora',
    logoUrl,
    primaryColor = COLORS.green,
    translucent = true,
    pulse = false,
    sx = {}
}) {
    const iconSize = 16;
    return (
        <Box
            sx={{
                backgroundColor: translucent ? 'rgba(255,255,255,0.85)' : '#fff',
                backdropFilter: 'blur(20px)',
                borderRadius: '14px',
                px: 1.5,
                py: 1.25,
                boxShadow: translucent ? '0 4px 16px rgba(0,0,0,0.2)' : '0 4px 12px rgba(0,0,0,0.1)',
                ...(pulse && {
                    animation: 'onbPushPulse 900ms ease-out',
                    '@keyframes onbPushPulse': {
                        '0%': { boxShadow: `0 0 0 0 rgba(60,213,104,0.7)`, transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.03)' },
                        '100%': { boxShadow: `0 0 0 18px rgba(60,213,104,0)`, transform: 'scale(1)' }
                    }
                }),
                ...sx
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                {/* The app icon of the push — the store's logo, like on the springboard
                    of the conclusion screen. The initial stands in until it is sent. */}
                {logoUrl ? (
                    <Box
                        component="img"
                        alt=""
                        src={logoUrl}
                        sx={{
                            width: iconSize,
                            height: iconSize,
                            borderRadius: '4px',
                            objectFit: 'cover',
                            flex: 'none'
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: iconSize,
                            height: iconSize,
                            borderRadius: '4px',
                            backgroundColor: primaryColor,
                            color: '#fff',
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 700,
                            fontSize: 9
                        }}
                    >
                        {storeName[0]}
                    </Box>
                )}
                <Box sx={{ fontWeight: 600, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.4, flex: 1 }}>
                    {storeName}
                </Box>
                <Box sx={{ fontSize: 10, color: 'rgba(0,0,0,0.5)' }}>{time}</Box>
            </Box>

            <Box sx={{ fontWeight: 700, fontSize: 13, lineHeight: 1.25, wordBreak: 'break-word' }}>{title}</Box>
            <Box sx={{ fontSize: 12, lineHeight: 1.3, color: 'rgba(0,0,0,0.7)', mt: 0.25, wordBreak: 'break-word' }}>{text}</Box>
        </Box>
    );
}
